<div
  class="w-full h-full flex flex-col items-center justify-center bg-white px-4"
>
  <div class="flex flex-col items-center justify-center gap-12">
    <div class="flex flex-col items-center gap-[19px] relative">
      <img
        src="../../../assets/icon/plane-shape.svg"
        alt=""
        class="plane-logo"
      />
      <span class="bell">🔕</span>

      <span class="header realtive"
        >Has desactivado las<br />notificaciones
        <img
          src="../../../assets/icon/whatsapp.svg"
          alt=""
          class="whatsapp-icon"
        />
      </span>
    </div>

    <div class="flex flex-col gap-12">
      <span class="info-messsage">
        Ya no recibirás notificaciones de<br />WhatsApp sobre tus pedidos.
      </span>

      <button (click)="goHome()">Volver a la web</button>
    </div>
  </div>
</div>
